(function($) {

    /*Workaround for targeting Bootstrap tabs from within a dropdown*/
    $('.dropdown-select .nav-link').on('click', function(e) {
        e.preventDefault();

        $this = $(this);

        // Updates active class within dropdown
        $this.tab('show');
        $('.dropdown-select .nav-link').removeClass('active');
        $this.addClass('active');

        var buttonText = $this.html();

        // Changes button text to match selected item
        $this.closest('.dropdown').find('.btn-select').html(buttonText);

        $('#dropdownContact').dropdown('hide');

    });

}(jQuery));